/**
 * Preserves original OneLink parameters when AppsFlyer uses default values
 * Also resets c/pid parameters for proper AppsFlyer attribution tracking
 * @param {string} originalLink - Original OneLink URL from CMS
 * @param {string} enhancedLink - Enhanced URL from AppsFlyer
 * @returns {string} - Final URL with preserved original parameters
 */
const preserveOneLinkParams = (originalLink, enhancedLink) => {
    // Create map of all query params from CMS OneLink
    const originalUrl = new URL(originalLink);
    const originalParamsMap = {};
    originalUrl.searchParams.forEach((value, key) => {
        originalParamsMap[key] = value;
    });

    const enhancedUrl = new URL(enhancedLink);

    // AppsFlyer defaults that we want to override
    const appsFlyerDefaults = {
        deep_link_sub1: 'tmweb',
        deep_link_sub2: 'organic'
    };

    // Parameter mapping: AppsFlyer param -> original CMS param names
    const paramMapping = {
        deep_link_sub1: ['campaign', 'c', 'utm_campaign'],
        deep_link_sub2: ['source', 'utm_source', 's', 'pid']
    };

    // Restore original values if AppsFlyer used defaults
    Object.entries(appsFlyerDefaults).forEach(
        ([appsFlyerParam, defaultValue]) => {
            if (
                enhancedUrl.searchParams.get(appsFlyerParam) ===
                defaultValue
            ) {
                const possibleNames =
                    paramMapping[appsFlyerParam] ||
                    /* istanbul ignore next */ [];
                const foundParam = possibleNames.find(
                    (paramName) => originalParamsMap[paramName]
                );
                if (foundParam) {
                    const originalValue = originalParamsMap[foundParam];

                    // Set the deep_link_sub parameter
                    enhancedUrl.searchParams.set(
                        appsFlyerParam,
                        originalValue
                    );

                    // Also reset the corresponding c/pid parameters for AppsFlyer attribution
                    if (appsFlyerParam === 'deep_link_sub1') {
                        enhancedUrl.searchParams.set('c', originalValue);
                    }
                    if (appsFlyerParam === 'deep_link_sub2') {
                        enhancedUrl.searchParams.set('pid', originalValue);
                    }
                }
            }
        }
    );

    return enhancedUrl.toString();
};

export default preserveOneLinkParams;
